import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
// 						local
import { ConfigService } from '../services/config.service';  // TODO: Deprecate
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import DevExpress from 'devextreme/bundles/dx.all';


@Injectable()
export class ServiceUtil {
  private get settings(): any { return this._configService.appSettings; }
  public get webApiServer(): string { return this.settings.idsServer; }

  constructor(private _http: HttpClient, private _oidcSecurityService: OidcSecurityService, private _configService: ConfigService) { }

  getFile(controller: string, action: string, body: any): Observable<any> {
    const token = this._oidcSecurityService.getAccessToken();

    let bodyJson = JSON.stringify(body);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });

    return this._http.post(`${this.webApiServer}/${controller}/${action}`, bodyJson, { headers, responseType: 'blob' }).pipe(map(result => {
      return result;
    }));

  }

  doPostRequest<T, U>(controller: string, action: string, body: T): Observable<U> {
    const header = this.getJsonContentTypeHeader();

    return this._http.post<U>(
      `${this.webApiServer}/${controller}/${action}`,
      JSON.stringify(body), { headers: header });
  }

  doPostRequestWithParams<T, U>(controller: string, action: string, body: T, params: HttpParams): Observable<U> {
    const header = this.getJsonContentTypeHeader();

    return this._http.post<U>(
      `${this.webApiServer}/${controller}/${action}`,
      JSON.stringify(body), { headers: header, params: params });
  }

  async doPostRequestAsync<T, U>(controller: string, action: string, body: T): Promise<U> {
    const header = this.getJsonContentTypeHeader();

    return this._http.post<U>(
      `${this.webApiServer}/${controller}/${action}`,
      JSON.stringify(body), { headers: header })
      .toPromise();
  }

  async doMultiPartPostRequestAsync<U>(controller: string, action: string, body: FormData): Promise<U> {
    const header = this.getMultiPartContentTypeHeader();

    return this._http.post<U>(
      `${this.webApiServer}/${controller}/${action}`,
      body, { headers: header })
      .toPromise();
  }

  async doMultiPartPostRequestWithParamsAsync<U>(controller: string, action: string, body: FormData, params: HttpParams): Promise<U> {
    const header = this.getMultiPartContentTypeHeader();

    return this._http.post<U>(
      `${this.webApiServer}/${controller}/${action}`,
      body, { headers: header, params: params })
      .toPromise();
  }

  async doPostRequestWithParamsAsync<T, U>(controller: string, action: string, body: T, params: HttpParams): Promise<U> {
    const header = this.getJsonContentTypeHeader();

    return this._http.post<U>(
      `${this.webApiServer}/${controller}/${action}`,
      JSON.stringify(body), { headers: header, params: params })
      .toPromise();
  } 

  doGetRequest<T>(controller: string, action: string): Observable<T> {
    const header = this.getJsonContentTypeHeader();

    return this._http.get<T>(
      `${this.webApiServer}/${controller}/${action}`,
      { headers: header });
  }

  doGetRequestWithParams<T>(controller: string, action: string, params: HttpParams): Observable<T> {
    const header = this.getJsonContentTypeHeader();

    return this._http.get<T>(
      `${this.webApiServer}/${controller}/${action}`,
      { headers: header, params: params });
  }  

  async doGetRequestAsync<T>(controller: string, action: string): Promise<T> {
    const header = this.getJsonContentTypeHeader();

    return this._http.get<T>(
      `${this.webApiServer}/${controller}/${action}`,
      { headers: header })
      .toPromise();
  }
  
  async doApiGetRequestWithParamsAsync<T>(controller: string, action: string, params: HttpParams): Promise<T> {
    const header = this.getJsonContentTypeHeader();

    return this._http.get<T>(
      `${this.webApiServer}/${controller}/${action}`,
      { headers: header, params: params })
      .toPromise();
  }

  async doGetRequestWithParamsAsync<T>(controller: string, action: string, params: HttpParams): Promise<T> {
    const header = this.getJsonContentTypeHeader();

    return this._http.get<T>(
      `${this.webApiServer}/${controller}/${action}`,
      { headers: header, params: params })
      .toPromise();
  }

  async createASPDataStoreWithToken(options: AspNetData.Options, token: string): Promise<DevExpress.data.CustomStore> {
		options.onBeforeSend = (operation, ajaxSettings) => {
			ajaxSettings.headers = {
				'Authorization': 'Bearer ' + token
			};
		};

		return Promise.resolve(AspNetData.createStore(options));
  }

  getJsonContentTypeHeader(): HttpHeaders {
    const header: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '01 Jan 2000 00:00:00 GMT'
    });
    return header;
  }

  getJsonContentTypeHeaderWithIdToken(token: string): HttpHeaders {
    let header = this.getJsonContentTypeHeader();

    if (token && token.length > 0) {
      header = header.set('Authorization', `Bearer ${token}`);
    } else {
      const idToken = this._oidcSecurityService.getAccessToken();
      header = header.set('Authorization', `Bearer ${idToken}`);
    }

    return header;
  }

  private getMultiPartContentTypeHeader(): HttpHeaders {
    const header: HttpHeaders = new HttpHeaders({
      // 'Content-Type': 'multipart/form-data',
      'Accept': '*/*'
    });
    return header;
  }

  async doPostRequestWithParamsAndFullUrlAsync<T, U>(url: string, body: T): Promise<U> {
    const header = this.getJsonContentTypeHeaderWithIdToken('');
    return this._http.post<U>(
      url,
      JSON.stringify(body), { headers: header })
      .toPromise();
  }
  async doPostRequestWithParamsAndFullUrlForGivenTokenAsync<T, U>(url: string, body: T, token: string): Promise<U> {
    const header = this.getJsonContentTypeHeaderWithIdToken(token);
    return this._http.post<U>(
      url,
      JSON.stringify(body), { headers: header })
      .toPromise();
  }

  async doGetRequestWithParamsAndFullUrlAsync<T>(url: string, params: HttpParams): Promise<T> {
    const header = this.getJsonContentTypeHeaderWithIdToken('');
    return this._http.get<T>(
      url,
      { headers: header, params: params })
      .toPromise();
  }
  async doGetRequestWithParamsAndFullUrlForGivenTokenAsync<T>(url: string, params: HttpParams, idToken: string): Promise<T> {
    const header = this.getJsonContentTypeHeaderWithIdToken(idToken);
    return this._http.get<T>(
      url,
      { headers: header, params: params })
      .toPromise();
  }
}
